import { toast } from '@/shared/ui/toast';

function getApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}

export function toastApiError(error: unknown, fallback: string, title?: string): void {
  toast({ title, description: getApiErrorMessage(error, fallback), variant: 'destructive' });
}
